import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && cfg.url && cfg.url.startsWith("/admin")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (e) {
        /* fall through */
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u);
const cleanPhone = (p) => {
  const s = p || "";
  return s.trim().startsWith("+242") ? s.replace(/[()]/g, "") : s.replace(/\(0\)/g, "");
};
export const telHref = (p) => `tel:${cleanPhone(p).replace(/[^+\d]/g, "")}`;
export const waHref = (p, text) =>
  `https://wa.me/${cleanPhone(p).replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export async function downloadFile(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "";
export const formatDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

export const youtubeId = (u) => {
  const m = (u || "").match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
  return m ? m[1] : null;
};
